import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getResidueCollectedList,
	addNewResidueCollected,
	updateResidueCollected,
	deleteResidueCollected,
	getResidueCollected,
	warehouseSendResidueCollected,
} from './thunk';

export const initialState = {
	itemResidueCollectedList: [],
	itemResidueCollectedDetail: null,
	isResidueCollectedLoading: false,
	isResidueCollectedSuccess: false,

	residueCollectedList: [],
	residueCollectedListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	requireReloadSelectionItemsGrid: false
};

const ResidueCollectedSlice = createSlice({
	name: 'ResidueCollecteds',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		setRequireReloadSelectionItemsGrid(state, action) {
			state.requireReloadSelectionItemsGrid = action.payload;
		}
	},
	extraReducers: builder => {
		builder.addCase(getResidueCollected.fulfilled, (state, action) => {
			state.isResidueCollectedLoading = false;
			state.isResidueCollectedSuccess = true;
			state.itemResidueCollectedDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getResidueCollected.pending, state => {
			state.isResidueCollectedLoading = true;
			state.isResidueCollectedSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getResidueCollected.rejected, (state, action) => {
			state.isResidueCollectedLoading = false;
			state.isResidueCollectedSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getResidueCollectedList.pending, state => {
			state.isResidueCollectedSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getResidueCollectedList.fulfilled, (state, action) => {
			state.itemResidueCollectedList = action.payload;
			state.residueCollectedList = action.payload;
			state.isLoadingList = false;
			state.isResidueCollectedSuccess = true;

			let residueCollectedListSelect = [];
			action.payload.map(item =>
				residueCollectedListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.residueCollectedListSelect = residueCollectedListSelect;
		});
		builder.addCase(getResidueCollectedList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isResidueCollectedSuccess = true;
		});
		builder.addCase(addNewResidueCollected.fulfilled, (state, action) => {
			state.itemResidueCollectedList.push(action.payload);
			state.residueCollectedList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewResidueCollected.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewResidueCollected.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateResidueCollected.fulfilled, (state, action) => {
			state.itemResidueCollectedList = state.itemResidueCollectedList.map(residueCollected =>
				residueCollected.residueCollectedname === action.payload.old_residueCollected
					? { ...residueCollected, ...action.payload.updated_residueCollected }
					: residueCollected
			);
			state.residueCollectedList = state.residueCollectedList.map(residueCollected =>
				residueCollected._id.toString() === action.payload._id.toString()
					? { ...residueCollected, ...action.payload }
					: residueCollected
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateResidueCollected.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateResidueCollected.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteResidueCollected.fulfilled, (state, action) => {
			state.itemResidueCollectedList = current(state.itemResidueCollectedList).filter(
				item => item._id !== action.payload._id
			);
			state.residueCollectedList = current(state.residueCollectedList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteResidueCollected.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteResidueCollected.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const {
	setRequireCloseModal,
	setRequireReloadSelectionItemsGrid
} = ResidueCollectedSlice.actions;

export default ResidueCollectedSlice.reducer;
